import React, { useState } from "react";
import { graphql, useLazyLoadQuery } from "react-relay";
import WaveSplitsGraph from "../WaveSplits/WaveSplitsGraph";
import HoleScoringGraph from "./HoleScoringGraph";
import FlexBreak from "../../../../../FlexBreak";

const GET_HOLE_SCORING = graphql`
  query HoleScoringQuery($eventId: ID!, $roundNum: Int) {
    pgaHoleScoring(eventId: $eventId, roundNum: $roundNum) {
      course {
        name
      }

      holeScores {
        hole {
          holeNum
          par
        }

        toParAverage
        eagles
        birdies
        pars
        bogeys
        doubleBogeys
        tripleBogeysOrWorse
      }
    }
  }
`;

export default function HoleScoring({ eventId, roundNum }) {
  const data = useLazyLoadQuery(GET_HOLE_SCORING, {
    eventId: eventId,
    roundNum: roundNum,
  });

    const windowWidth = document.body.clientWidth;

    let numPerRow = 6;

    if (windowWidth < 1024) {
        numPerRow = 3;
    }

    if (windowWidth < 550) {
        numPerRow = 2;
    }

  return data.pgaHoleScoring.map((holeScoring) => {
    return (
      <div
        key={holeScoring.course.name}
        style={{ margin: "0 auto", width: `${155 * numPerRow + 60}px` }}
      >
        <h2>
          Hole Scoring - R{roundNum}
          <br />
          {holeScoring.course.name}
        </h2>
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "space-evenly",
            alignItems: "space-evenly",
            width: `${155 * numPerRow + 60}px`,
            height: `${155 * (18 / numPerRow)}px`,
          }}
        >
          {holeScoring.holeScores.map((holeScores) => {
            return (
              <HoleScoringGraph
                key={holeScores.hole.holeNum}
                hole={holeScores.hole}
                holeScores={holeScores}
              />
            );
          })}
          <FlexBreak />
        </div>
      </div>
    );
  });
}
